module.exports = __webpack_public_path__ + "images/hero-ca.58f250773848fdb9e1482e9b3b4c831d.jpg";